import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'auth',
    loadComponent: () =>
      import('./authenticate/authenticate.component').then((c) => c.AuthenticateComponent),
  },
  {
    path: 'oauth/verify/:rtk',
    loadComponent: () => import('./oauth/oauth.component').then((c) => c.OauthComponent),
  },
];
